export default __webpack_public_path__ + "static/media/w1.be5d5d69.webp";